import { AuthClient } from '@acast-tech/auth-client';
import { config } from './config';

const authClient = new AuthClient({
  clientId: config.auth0ClientId,
  audience: config.auth0Audience,
  domain: config.auth0Domain,
});

export { authClient };
